import { DataSource, Label, Layout, Panel, Splitter, Table } from "@mcleod/components";

export abstract class AutogenLayoutPartialShipmentPlanningSplitView extends Layout {
    labelManifests: Label;
    labelOrders: Label;
    panelManifest: Panel;
    panelManifestsContainer: Panel;
    panelManifestsFilter: Panel;
    panelManifestsHeaderTab: Panel;
    panelManifestsStrip: Panel;
    panelOrders: Panel;
    panelOrdersContainer: Panel;
    panelOrdersFilter: Panel;
    panelOrdersHeaderTab: Panel;
    panelOrdersStrip: Panel;
    sourcePartialShipmentPlanningManifests: DataSource;
    sourcePartialShipmentPlanningOrders: DataSource;
    splitterPartialShipmentPlanningView: Splitter;
    tableManifests: Table;
    tableOrders: Table;
}
